import React from 'react';
import styled from '@emotion/styled';

import OnboardPane from '../../../OnboardPane';

import { SPACING, FONT, MEDIA_QUERY, COLORS3 } from '../../../../../styles/emotion';

const mobile =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails1_mobile.jpg';
const tablet =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails1_tablet.jpg';
const desktop =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails1_desktop.jpg';
const Tags =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails1_tags.svg';

const imgSrcs = {
  mobile,
  tablet,
  desktop,
  alt: '',
};

const BottomContent = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  img {
    max-width: 40%;
    margin: 0 0 ${SPACING.S32} ${SPACING.S32};
    ${MEDIA_QUERY.NOT_MOBILE} {
      margin: 0 0 ${SPACING.LG} ${SPACING.LG};
    }
  }
  span {
    align-self: flex-end;
    color: ${COLORS3.WHITE_100};
    margin: 16px;
    ${FONT.textSizeRegular(FONT.FONT_SIZE_EXTRA_SMALL)}
  }
`;

const Content = (
  <BottomContent>
    <img src={Tags} alt="" />
    <span>Rancho Las Lomas</span>
  </BottomContent>
);

const WeddingLocation = (): JSX.Element => {
  return <OnboardPane imgSrcs={imgSrcs} hed={Content} />;
};

export default WeddingLocation;
